import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
}

export function formatTime(timeString) {
  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
}

export function getStatusLabel(status) {
  const labels = {
    recibido: 'Recibido',
    en_proceso: 'En Proceso',
    listo: 'Listo',
    entregado: 'Entregado',
    agendado: 'Agendado',
    confirmado: 'Confirmado',
    cancelado: 'Cancelado',
    pendiente: 'Pendiente',
    pagado: 'Pagado',
  };
  return labels[status] || status;
}

export function getVehicleTypeLabel(type) {
  const labels = {
    sedan: 'Sedán',
    suv: 'SUV',
    pickup: 'Pickup',
    motocicleta: 'Motocicleta',
    otro: 'Otro',
  };
  return labels[type] || type;
}

export function getRoleLabel(role) {
  const labels = {
    admin: 'Administrador',
    gerente: 'Gerente',
    cajero: 'Cajero',
    operador: 'Operador',
    cliente: 'Cliente',
  };
  return labels[role] || role;
}
